module.exports = __webpack_public_path__ + "static/img/loding.1503cae.png";


//////////////////
// WEBPACK FOOTER
// ./static/imgV2/loding.png
// module id = 5sPO
// module chunks = 1